import React, { useCallback, useEffect, useState } from "react";
import { CircleNotch, Bank } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export default function Banking({ cid }) {
  const [banks, setBanks] = useState([]); const [lid, setLid] = useState("");
  const [recon, setRecon] = useState(null); const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try { const r = await api.get(`/acc/${cid}/ledgers`); const b = r.data.ledgers.filter((l) => ["Bank Accounts", "Bank OD / CC"].includes(l.group)); setBanks(b); if (b.length) setLid(b[0].ledger_id); } catch (e) { console.error(e); }
    })();
  }, [cid]);

  const load = useCallback(async () => { if (!lid) return; setLoading(true); try { setRecon((await api.get(`/acc/${cid}/bank-recon/${lid}`)).data); } catch (e) { console.error(e); } setLoading(false); }, [cid, lid]);
  useEffect(() => { load(); }, [load]);

  const mark = async (row) => {
    try {
      await api.post(`/acc/${cid}/bank-recon/mark`, { voucher_id: row.voucher_id, entry_index: row.entry_index, cleared: !row.cleared, clearing_date: !row.cleared ? new Date().toISOString().slice(0, 10) : "" });
      await load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div data-testid="acc-banking">
      {banks.length === 0 ? (
        <div className="bg-white border border-[#2A2625]/10 rounded-2xl p-8 text-center" data-testid="no-bank">
          <Bank size={36} weight="duotone" className="text-[#F29A86] mx-auto mb-2" />
          <p className="text-sm text-[#8C8381]">Add a ledger under <b>Bank Accounts</b> in Chart of Accounts to reconcile.</p>
        </div>
      ) : (
        <>
          <select data-testid="bank-select" value={lid} onChange={(e) => setLid(e.target.value)} className="mb-4 bg-[#FCFAF8] border border-[#2A2625]/15 rounded-xl px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#FFB8A5] min-w-[220px]">{banks.map((b) => <option key={b.ledger_id} value={b.ledger_id}>{b.name}</option>)}</select>
          {loading && <CircleNotch size={22} className="animate-spin text-[#F29A86]" />}
          {recon && (
            <>
              <div className="flex gap-3 text-sm mb-4 flex-wrap">
                <div className="bg-white border border-[#2A2625]/10 rounded-xl px-4 py-2" data-testid="book-bal">Balance per books<br /><b>{inr(recon.book_balance)}</b></div>
                <div className="bg-white border border-[#2A2625]/10 rounded-xl px-4 py-2" data-testid="cleared-bal">Cleared (per bank)<br /><b>{inr(recon.cleared_balance)}</b></div>
                <div className="bg-white border border-[#2A2625]/10 rounded-xl px-4 py-2" data-testid="uncleared-bal">Un-reconciled<br /><b>{inr(recon.uncleared)}</b></div>
              </div>
              <div className="bg-white border border-[#2A2625]/10 rounded-2xl overflow-hidden" data-testid="recon-table">
                {recon.rows.length === 0 ? <p className="p-6 text-sm text-[#8C8381]">No bank transactions yet.</p> : (
                  <table className="w-full text-sm">
                    <thead><tr className="text-left text-[#8C8381] text-xs uppercase bg-[#FCFAF8]"><th className="px-4 py-3">Date</th><th className="px-4 py-3">Narration</th><th className="px-4 py-3 text-right">Debit</th><th className="px-4 py-3 text-right">Credit</th><th className="px-4 py-3 text-center">Cleared</th></tr></thead>
                    <tbody>
                      {recon.rows.map((r, i) => <tr key={i} className="border-t border-[#2A2625]/8"><td className="px-4 py-2 whitespace-nowrap">{r.date}</td><td className="px-4 py-2 text-xs text-[#8C8381]">{r.narration}</td><td className="px-4 py-2 text-right font-mono">{r.dr ? inr(r.dr) : ""}</td><td className="px-4 py-2 text-right font-mono">{r.cr ? inr(r.cr) : ""}</td><td className="px-4 py-2 text-center"><input type="checkbox" data-testid={`recon-check-${i}`} checked={r.cleared} onChange={() => mark(r)} className="accent-[#F29A86] w-4 h-4" /></td></tr>)}
                    </tbody>
                  </table>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
